// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__vcNDC","btn":"Pagination_btn__8zdFY","active":"Pagination_active__DDld0","ellipsis":"Pagination_ellipsis__dtjnQ","info":"Pagination_info__-44Zc"};